import { QueryClient } from "@tanstack/react-query";

let queryClient: QueryClient | null = null;
export const getQueryClient = () => {
  queryClient ??= new QueryClient({
    defaultOptions: {
      queries: { staleTime: 1000 * 3, refetchOnWindowFocus: true },
    },
  });

  return queryClient;
};
